import {Gamecloud} from "../../../../gamecloud";
import {SquadMapcycleUI} from "./SquadMapcycleUI";
import {IMapItemData} from "../../../../interface";
import {Sortable} from '@shopify/draggable/lib/es5/draggable.bundle';

interface ISortableEvent {
  data: {
    dragEvent: any;
    newContainer: any;
    newIndex: number;
    oldContainer: any;
    oldIndex: number;
  }
}

/**
 * Mapcycle
 */
export class SquadMapcycle extends Gamecloud {
  // sortable instance
  private sortable = null;

  public constructor(private ui: SquadMapcycleUI, private levelsData: IMapItemData[], private layersData: IMapItemData[], private form: any) {
    super();

    // enable add button
    this.ui.enableAddButton();

    // listen to add button click
    this.ui.onAddButtonClick(this.handleAddButtonClick.bind(this));

    // listen to change of map rotation mode
    this.ui.onChangeMapRotationMode(this.render.bind(this));

    // render and init draggable
    this.render();
    this.sortable = this.initDraggable();

    // listen to delete even
    window.addEventListener('removemap', (event) => {
      this.delete(event);
    });
  }

  /**
   * Handle save button click
   * Pushing data to array and render again
   */
  private handleAddButtonClick(data: IMapItemData) {
    if (this.ui.getMapRotationModeValue().match('^Level')) {
      this.levelsData.push(data);
    } else if (this.ui.getMapRotationModeValue().match('^Layer')) {
      this.layersData.push(data);
    }

    this.render();
  }

  /**
   * Render the maps
   */
  private render() {
    if (this.ui.getMapRotationModeValue().match('^Level')) {
      this.ui.render(this.levelsData, this.form);
    } else if (this.ui.getMapRotationModeValue().match('^Layer')) {
      this.ui.render(this.layersData, this.form);
    }
  }

  /**
   * Remove map from array
   * index will provided by event
   * @param event - custom event
   */
  private delete(event: any) {
    if (this.ui.getMapRotationModeValue().match('^Level')) {
      this.levelsData = this.levelsData.filter((item, index) => index !== event.detail.index);
    } else if (this.ui.getMapRotationModeValue().match('^Layer')) {
      this.layersData = this.layersData.filter((item, index) => index !== event.detail.index);
    }

    this.render();
  }

  /**
   * init draggable feature
   * reorder after drop
   */
  private initDraggable() {
    const containerSelector = '.mapcycle__maps';
    const containers = document.querySelectorAll(containerSelector);

    if (containers.length === 0) {
      return false;
    }

    const sortable = new Sortable(containers, {
      draggable: '.map',
      delay: 200,
      mirror: {
        appendTo: containerSelector,
        constrainDimensions: true,
      },
    });

    //listen to dropevent
    sortable.on('sortable:stop', (ev: ISortableEvent) => {
      if (this.ui.getMapRotationModeValue().match('^Level')) {
        this.levelsData = this.reOrder(ev, this.levelsData);
      } else if (this.ui.getMapRotationModeValue().match('^Layer')) {
        this.layersData = this.reOrder(ev, this.layersData);
      }

      this.render();
    });

    return sortable;
  }

  /**
   * Reorder the data
   * @param event - drop event
   */
  private reOrder(event, originalArray) {
    const movedItem = originalArray.find((item, index) => index === event.oldIndex);
    const remainingItems = originalArray.filter((item, index) => index !== event.oldIndex);

    const reorderedItems = [
      ...remainingItems.slice(0, event.newIndex),
      movedItem,
      ...remainingItems.slice(event.newIndex)
    ];

    return reorderedItems;
  }
}
